interface FinalCTAProps {
  onCTAClick: () => void;
}

export default function FinalCTA({ onCTAClick }: FinalCTAProps) {
  return (
    <section className="relative w-full py-32 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/341baa8f846335b9a6684c04fa77a1bf.jpg"
          alt="Football Field"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <h2 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-white mb-8 leading-tight">
          Support Caledonia Youth Football.<br />
          <span className="text-yellow-400">Promote Your Business</span><br />
          In The Community.
        </h2>
        
        <p className="text-base sm:text-xl md:text-2xl text-gray-100 mb-12 max-w-3xl mx-auto font-medium leading-relaxed">
          Join the local businesses already making a difference in young lives while building lasting connections with families in Caledonia.
        </p>

        <button
          onClick={onCTAClick}
          className="px-6 py-4 sm:px-10 sm:py-5 md:px-12 md:py-6 bg-purple-700 hover:bg-purple-800 text-white text-base sm:text-xl md:text-2xl font-black rounded-xl transition-all duration-300 transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
        >
          Become A CYFA Sponsor
        </button>
      </div>
    </section>
  );
}